/** 与创建报价 / 产品列表「设置报价」共用的当前分类 */
export const QUOTATION_CATEGORY_KEY = 'quotation_category'

export function readLocalQuotationCategoryId() {
	try {
		const fromSession = sessionStorage.getItem(QUOTATION_CATEGORY_KEY)
		if (fromSession) {
			const id = Number(fromSession)
			if (id > 0) return id
		}
		const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
		const id = Number(userInfo.quotation_category_id || 0)
		return id > 0 ? id : 0
	} catch (e) {
		return 0
	}
}

export function syncLocalQuotationCategoryId(categoryId) {
	const id = Number(categoryId || 0)
	try {
		if (id > 0) {
			sessionStorage.setItem(QUOTATION_CATEGORY_KEY, String(id))
			const raw = localStorage.getItem('userInfo')
			if (raw) {
				const userInfo = JSON.parse(raw)
				userInfo.quotation_category_id = id
				localStorage.setItem('userInfo', JSON.stringify(userInfo))
			}
		} else {
			sessionStorage.removeItem(QUOTATION_CATEGORY_KEY)
		}
	} catch (e) {
		/* ignore */
	}
	return id > 0 ? id : 0
}

/**
 * 拉取用户当前报价分类（优先接口，失败时读本地缓存）
 * @param {Function} fetchFn Vue 实例的 $fetch
 * @returns {Promise<{ categoryId: number, categoryName: string }>}
 */
export function fetchQuotationCategory(fetchFn) {
	return fetchFn('addons/hlm/api.User/getQuotationCategory')
		.then(function (res) {
			if (res && res.code == 1 && res.data) {
				const categoryId = Number(res.data.category_id || 0)
				const category = res.data.category || null
				const categoryName = category && category.name ? String(category.name) : ''
				syncLocalQuotationCategoryId(categoryId > 0 ? categoryId : 0)
				return {
					categoryId: categoryId > 0 ? categoryId : 0,
					categoryName: categoryId > 0 ? categoryName : ''
				}
			}
			const localId = readLocalQuotationCategoryId()
			return { categoryId: localId, categoryName: '' }
		})
		.catch(function () {
			const localId = readLocalQuotationCategoryId()
			return { categoryId: localId, categoryName: '' }
		})
}
